import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[hasAddPermissions], [hasStopPermissions]',
    standalone: false
})
export class HasPermissionsDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private authService: AuthService
  ) {}

  @Input()
  set hasAddPermissions(neededPermissions: string[]) {
    const userPermissions = this.authService.getPermissions();
    const hasAccess = neededPermissions.every((p) =>
      userPermissions.includes(p)
    );

    if (hasAccess) {
      this.showComponent();
    } else {
      this.removeComponent();
    }
  }

  @Input()
  set hasStopPermissions(neededPermissions: string[]) {
    const userPermissions = this.authService.getPermissions();
    const hasAccess = neededPermissions.every((p) =>
      userPermissions.includes(p)
    );

    if (hasAccess) {
      this.showComponent();
    } else {
      this.removeComponent();
    }
  }

  removeComponent(): void {
    this.viewContainerRef.clear();
  }

  showComponent(): void {
    this.viewContainerRef.clear();
    this.viewContainerRef.createEmbeddedView(this.templateRef).rootNodes[0];
  }
}
